<template>
  <div>
    <v-row dense>
      <v-col sm="2" xl="2" md="2" lg="2" class=" flex-justify-end flex-center">
        合同到期日期：
      </v-col>
      <v-col sm="8" xl="8" md="8" lg="8">
        <form-item
            v-model="info.value"
            class="flex-0 flex-shrink-0"
            style="width: 250px"
            placeholder="合同到期日期"
            allow-close
            type="date"
            />
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="2" xl="2" md="2" lg="2" />
      <v-col sm="8" xl="8" md="8" lg="8">
        <v-btn small color="primary" depressed min-width="120" class="mr-2" height="30" style="padding:0 8px" @click="saveContractExpiration">保存</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      initInfo: {},
      info: {}
    }
  },
  mounted() {
    this.getContractExpiration()
  },
  methods: {
    getContractExpiration() {
      this.$http.get(this.$api.settingGetContractExpireDate, { data: {}, type: 'application/x-www-form-urlencoded' }).then(res => {
        this.initInfo.value = res.result
        this.info.value = res.result
      }).catch(() => {
        this.info = {}
      })
    },
    saveContractExpiration() {
      this.btnLoading = true
      this.$http.post(this.$api.settingSaveContractExpireDate, { data: { ...this.info } }).then(res => {
        this.$message.success(res.result || res.message)
        this.btnLoading = false
      }).catch(() => {
        this.btnLoading = false
        this.info = this.$deepClone(this.initInfo)
      })
    }
  }
}
</script>

<style>

</style>
